<script setup>
import { computed } from 'vue'
import AuthIcon from './AuthIcon.vue'

const props = defineProps({
  notice: { type: Object, default: null },
})

const type = computed(() => ['error', 'success', 'info'].includes(props.notice?.type)
  ? props.notice.type
  : 'info')
const panelClass = computed(() => ({
  'auth-login__error-block': type.value === 'error',
  'auth-login__success-banner': type.value === 'success',
  'auth-login__info-banner': type.value === 'info',
}))
const role = computed(() => type.value === 'error' ? 'alert' : 'status')
const icon = computed(() => type.value === 'success' ? 'check' : 'info')
</script>

<template>
  <div v-if="notice?.message" class="auth-login__notice-panel" :class="panelClass" :role="role">
    <AuthIcon :name="icon" />
    <div class="auth-login__notice-content">
      <p>{{ notice.message }}</p>
      <p v-if="notice.description">{{ notice.description }}</p>
    </div>
  </div>
</template>

<style scoped>
.auth-login__notice-panel {
  align-items: center;
  display: flex;
  gap: 10px;
}

.auth-login__notice-content {
  min-width: 0;
}

.auth-login__notice-content p {
  margin: 4px 0 0;
}
</style>
